import {
  GET_USERS_START,
  GET_USERS_FULFILLED,
  GET_USERS_REJECTED,
  GET_GROUPS_START,
  GET_GROUPS_FULFILLED,
  GET_GROUPS_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_JOURNAL_ENTRIES_START,
  FETCH_JOURNAL_ENTRIES_FULFILLED,
  FETCH_JOURNAL_ENTRIES_REJECTED,
  SET_SELECTED_ATHLETE,
  FETCH_ENTRIES_FOR_ATHLETE_START,
  FETCH_ENTRIES_FOR_ATHLETE_FULFILLED,
  FETCH_ENTRIES_FOR_ATHLETE_REJECTED,
  SET_CURRENT_GROUP,
  FETCH_ENTRIES_FOR_GROUP_START,
  FETCH_ENTRIES_FOR_GROUP_FULFILLED,
  FETCH_ENTRIES_FOR_GROUP_REJECTED,
  FETCH_ME_JOURNAL_ENTRIES_START,
  FETCH_ME_JOURNAL_ENTRIES_FULFILLED,
  FETCH_ME_JOURNAL_ENTRIES_REJECTED,
  FETCH_NEXT_JOURNAL_PAGE_START,
  FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
  FETCH_NEXT_JOURNAL_PAGE_REJECTED,
  CREATE_JOURNAL_ENTRIES_START,
  CREATE_JOURNAL_ENTRIES_FULFILLED,
  CREATE_JOURNAL_ENTRIES_REJECTED,
  CREATE_ENTRY_TO_ATHLETE_START,
  CREATE_ENTRY_TO_ATHLETE_FULFILLED,
  CREATE_ENTRY_TO_ATHLETE_REJECTED,
  SET_EDIT_JOURNAL_ENTRY,
  UPDATE_JOURNAL_ENTRY_START,
  UPDATE_JOURNAL_ENTRY_FULFILLED,
  UPDATE_JOURNAL_ENTRY_REJECTED,
  DELETE_ME_JOURNAL_ENTRIES_START,
  DELETE_ME_JOURNAL_ENTRIES_FULFILLED,
  DELETE_ME_JOURNAL_ENTRIES_REJECTED,
  SET_FILTER_OPTIONS,
  SET_DATE_RANGE,
  SET_IS_END_OF_LIST,
  SET_EXERCISE_TAB,
  SET_TEMP_EXERCISE,
  SET_EXERCISE_FILTER,
  UPLOAD_MEDIA_START,
  UPLOAD_MEDIA_FULFILLED,
  UPLOAD_MEDIA_REJECTED,
  SET_UPLOAD_MEDIA_FALSE,
  UPLOAD_COMMENT_MEDIA_START,
  UPLOAD_COMMENT_MEDIA_FULFILLED,
  UPLOAD_COMMENT_MEDIA_REJECTED,
  UPLOAD_COMMENT_MEDIA_URL_START,
  UPLOAD_COMMENT_MEDIA_URL_FULFILLED,
  UPLOAD_COMMENT_MEDIA_URL_REJECTED,
  SET_UPLOAD_COMMENT_MEDIA_FALSE,
  SET_COMMENT_MEDIA_TARGET,
  SET_REMOVE_MEDIA_ARRAY,
  CLEAR_REMOVE_MEDIA_ARRAY,
  SET_MESSAGE_MEDIA_URL,
  SET_ACTIVE_REDUX_MODAL,
  SET_SUB_ACTIVE_REDUX_MODAL,
  SET_JOURNAL_TAB,
  CREATE_JOURNAL_ENTRY_COMMENT_START,
  CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED,
  CREATE_JOURNAL_ENTRY_COMMENT_REJECTED,
  SET_EDIT_COMMENT,
  EDIT_JOURNAL_ENTRY_COMMENT_START,
  EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED,
  EDIT_JOURNAL_ENTRY_COMMENT_REJECTED,
  DELETE_JOURNAL_ENTRY_COMMENT_START,
  DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED,
  DELETE_JOURNAL_ENTRY_COMMENT_REJECTED,
  SET_REPORT_POST_ID,
  SUBMIT_SUPPORT_START,
  SUBMIT_SUPPORT_FULFILLED,
  SUBMIT_SUPPORT_REJECTED,
  RESET_SUPPORT_ERROR,
  RESET_ENTRY_ERROR,
  RESET_COMMENT_ERROR,
} from './actionTypes';

const initialState = {
  activeExerciseTab: 'L',
  activeTab: 'SINGLE_ATHLETE',
  commentError: {},
  commentMediaTarget: {},
  commentUploadMedia: {},
  currentAthlete: { first: 'My', last: 'Journal' },
  currentGroup: {
    id: null,
    name: null,
  },
  currentJournalEntry: {},
  currentPage: 1,
  dateRange: {},
  editedComment: {},
  entryError: null,
  exerciseIdFilter: {},
  exercises: [],
  exercisesError: null,
  filterExercise: {},
  groups: [],
  groupsError: null,
  isEndOfList: false,
  journalEntriesData: [],
  journalEntriesError: null,
  mediaOnly: false,
  messageMediaUrl: '',
  page: 1,
  removeMediaArray: [],
  reportPost: null,
  submitSupportError: null,
  tempExercise: {},
  uploadMedia: [],
  uploadMediaExtended: [],
  users: [],
  usersError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_USERS_START: {
      return {
        ...state,
        usersError: null,
      };
    }
    case GET_USERS_FULFILLED: {
      const allUsers = action.payload;

      const athletes = allUsers.filter((user) => user.admin === 0);

      return {
        ...state,
        users: allUsers,
        allAthletes: athletes,
      };
    }
    case GET_USERS_REJECTED: {
      return {
        ...state,
        usersError: action.payload,
      };
    }
    case GET_GROUPS_START: {
      return {
        ...state,
        groupsError: null,
      };
    }
    case GET_GROUPS_FULFILLED: {
      const allGroups = action.payload;

      return {
        ...state,
        groups: allGroups,
      };
    }
    case GET_GROUPS_REJECTED: {
      return {
        ...state,
        groupsError: action.payload,
      };
    }
    case FETCH_EXERCISES_START: {
      return {
        ...state,
        exercisesError: null,
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      const exercises = action.payload;

      return {
        ...state,
        exercises,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        exercises: [],
        exercisesError: action.payload,
      };
    }
    case FETCH_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        journalEntriesError: null,
      };
    }
    // fetching journal entries for ALL ATHLETES
    case FETCH_JOURNAL_ENTRIES_FULFILLED: {
      const data = action.payload.filteredData;
      return {
        ...state,
        journalEntriesData: data,
        currentAthlete: {},
        currentGroup: { id: null, name: null },
        isEndOfList: action.payload.isEndOfList,
        page: 1,
        mediaOnly: action.payload.mediaOnly,
      };
    }
    case FETCH_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        journalEntriesData: [],
        journalEntriesError: action.payload,
      };
    }
    case SET_SELECTED_ATHLETE: {
      return {
        ...state,
        currentAthlete: action.payload,
      };
    }
    case FETCH_ENTRIES_FOR_ATHLETE_START: {
      return {
        ...state,
        journalEntriesError: null,
      };
    }
    case FETCH_ENTRIES_FOR_ATHLETE_FULFILLED: {
      const athleteJournalEntries = action.payload.filterForNotPrivate;

      return {
        ...state,
        // I filtered the data in the action fuction for entries created by the athlete
        journalEntriesData: athleteJournalEntries,
        currentGroup: { id: null, name: null },
        isEndOfList: action.payload.isEndOfList,
        mediaOnly: action.payload.mediaOnly,
        page: 1,
      };
    }
    case FETCH_ENTRIES_FOR_ATHLETE_REJECTED: {
      return {
        ...state,
        journalEntriesData: [],
        journalEntriesError: action.payload,
      };
    }
    case SET_CURRENT_GROUP: {
      return {
        ...state,
        currentGroup: action.payload,
      };
    }
    case FETCH_ENTRIES_FOR_GROUP_START: {
      return {
        ...state,
        journalEntriesError: null,
      };
    }
    case FETCH_ENTRIES_FOR_GROUP_FULFILLED: {
      const groupJournalEntries = action.payload.filterForNotPrivate;

      return {
        ...state,
        // I filtered the data in the action fuction for entries created by the athlete
        journalEntriesData: groupJournalEntries,
        currentAthlete: {},
        isEndOfList: action.payload.isEndOfList,
        mediaOnly: action.payload.mediaOnly,
        page: 1,
      };
    }
    case FETCH_ENTRIES_FOR_GROUP_REJECTED: {
      return {
        ...state,
        journalEntriesData: [],
        journalEntriesError: action.payload,
      };
    }
    case FETCH_ME_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        journalEntriesError: null,
      };
    }
    case FETCH_ME_JOURNAL_ENTRIES_FULFILLED: {
      const { data } = action.payload;
      return {
        ...state,
        journalEntriesData: data,
        currentAthlete: {
          first: 'My', last: 'Journal', id: action.payload.currentUser.id, pic: action.payload.currentUser.pic,
        },
        currentGroup: { id: null, name: null },
        isEndOfList: action.payload.isEndOfList,
        mediaOnly: action.payload.mediaOnly || false,
        page: 1,
      };
    }
    case FETCH_ME_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        journalEntriesData: [],
        journalEntriesError: action.payload,
      };
    }
    case FETCH_NEXT_JOURNAL_PAGE_START: {
      return {
        ...state,
        journalEntriesError: null,
      };
    }
    case FETCH_NEXT_JOURNAL_PAGE_FULFILLED: {
      const { journalEntriesData } = state;

      const newJournalEntriesData = journalEntriesData.concat(action.payload.data);

      return {
        ...state,
        journalEntriesData: newJournalEntriesData,
        page: action.payload.page,
        isEndOfList: action.payload.isEndOfList,
      };
    }
    case FETCH_NEXT_JOURNAL_PAGE_REJECTED: {
      return {
        ...state,
        journalEntriesError: action.payload,
      };
    }
    case CREATE_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        entryError: null,
      };
    }
    case CREATE_JOURNAL_ENTRIES_FULFILLED: {
      const { journalEntriesData } = state;
      const newJournalEntriesData = [action.payload, ...journalEntriesData];
      return {
        ...state,
        journalEntriesData: newJournalEntriesData,
        activeModal: '',
        uploadMedia: [],
        uploadMediaExtended: [],
        removeMediaArray: [],
      };
    }
    case CREATE_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        entryError: action.payload,
      };
    }
    case CREATE_ENTRY_TO_ATHLETE_START: {
      return {
        ...state,
        entryError: null,
      };
    }
    case CREATE_ENTRY_TO_ATHLETE_FULFILLED: {
      const { journalEntriesData } = state;
      const newJournalEntriesData = [action.payload, ...journalEntriesData];
      return {
        ...state,
        journalEntriesData: newJournalEntriesData,
        activeModal: '',
        uploadMedia: [],
        uploadMediaExtended: [],
        removeMediaArray: [],
      };
    }
    case CREATE_ENTRY_TO_ATHLETE_REJECTED: {
      return {
        ...state,
        entryError: action.payload,
      };
    }
    case SET_EDIT_JOURNAL_ENTRY: {
      return {
        ...state,
        currentJournalEntry: action.payload.entry,
        uploadMedia: action.payload.mediaIds,
        uploadMediaExtended: action.payload.media,
      };
    }
    case UPDATE_JOURNAL_ENTRY_START: {
      return {
        ...state,
        entryError: null,
      };
    }
    case UPDATE_JOURNAL_ENTRY_FULFILLED: {
      const { journalEntriesData } = state;
      const arrayWithUpdatedEntry = journalEntriesData.map((journalEntry) => {
        if (journalEntry.id === action.payload.id) {
          return action.payload;
        }
        return journalEntry;
      });
      return {
        ...state,
        currentJournalEntry: {},
        journalEntriesData: arrayWithUpdatedEntry,
        activeModal: '',
        uploadMedia: [],
        uploadMediaExtended: [],
        removeMediaArray: [],
      };
    }
    case UPDATE_JOURNAL_ENTRY_REJECTED: {
      return {
        ...state,
        entryError: action.payload,
      };
    }
    case DELETE_ME_JOURNAL_ENTRIES_START: {
      return {
        ...state,
        entryError: null,
      };
    }
    case DELETE_ME_JOURNAL_ENTRIES_FULFILLED: {
      const { journalEntriesData } = state;
      const deleteArray = action.payload.successful;
      // filter and return entries that are not in the delete array
      const newArray = journalEntriesData.filter((entry) => !deleteArray.includes(entry.id));

      return {
        ...state,
        journalEntriesData: newArray,
      };
    }
    case DELETE_ME_JOURNAL_ENTRIES_REJECTED: {
      return {
        ...state,
        entryError: action.payload,
      };
    }
    case SET_FILTER_OPTIONS: {
      return {
        ...state,
        mediaOnly: action.payload.mediaOnly,
        dateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
        filterExercise: action.payload.exercise,
      };
    }
    case SET_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.payload,
      };
    }
    case SET_IS_END_OF_LIST: {
      return {
        ...state,
        isEndOfList: action.payload.isEndOfList,
      };
    }
    case SET_EXERCISE_TAB: {
      return {
        ...state,
        activeExerciseTab: action.payload,
      };
    }
    case SET_TEMP_EXERCISE: {
      return {
        ...state,
        tempExercise: action.payload,
      };
    }
    case SET_EXERCISE_FILTER: {
      return {
        ...state,
        exerciseIdFilter: action.payload,
      };
    }
    case UPLOAD_MEDIA_START: {
      return {
        ...state,
        uploadMediaError: null,
      };
    }
    case UPLOAD_MEDIA_REJECTED: {
      return {
        ...state,
        uploadMediaError: action.payload,
      };
    }
    case UPLOAD_MEDIA_FULFILLED: {
      const { uploadMedia } = state;
      const uploadMediaArray = [...uploadMedia, action.payload.id];
      const { uploadMediaExtended } = state;
      const uploadMediaExtendedArray = [...uploadMediaExtended, action.payload];

      return {
        ...state,
        uploadMedia: uploadMediaArray,
        uploadMediaExtended: uploadMediaExtendedArray,
      };
    }
    case SET_UPLOAD_MEDIA_FALSE: {
      return {
        ...state,
        uploadMedia: [],
        uploadMediaExtended: [],
      };
    }
    case UPLOAD_COMMENT_MEDIA_START: {
      return {
        ...state,
        uploadCommentMediaError: null,
      };
    }
    case UPLOAD_COMMENT_MEDIA_REJECTED: {
      return {
        ...state,
        uploadCommentMediaError: action.payload,
      };
    }
    case UPLOAD_COMMENT_MEDIA_FULFILLED: {
      return {
        ...state,
        commentUploadMedia: {
          media: action.payload.media,
          entryId: action.payload.entryId,
          commentId: action.payload.commentId,
        },
      };
    }
    case UPLOAD_COMMENT_MEDIA_URL_START: {
      return {
        ...state,
        uploadCommentMediaError: null,
      };
    }
    case UPLOAD_COMMENT_MEDIA_URL_REJECTED: {
      return {
        ...state,
        uploadCommentMediaError: action.payload,
      };
    }
    case UPLOAD_COMMENT_MEDIA_URL_FULFILLED: {
      return {
        ...state,
        commentUploadMedia: {
          media: action.payload.media,
          entryId: action.payload.entryId,
          commentId: action.payload.commentId,
        },
      };
    }
    case SET_UPLOAD_COMMENT_MEDIA_FALSE: {
      return {
        ...state,
        commentUploadMedia: {},
      };
    }
    case SET_COMMENT_MEDIA_TARGET: {
      return {
        ...state,
        commentMediaTarget: {
          entryId: action.payload.entryId,
          commentId: action.payload.commentId,
        },
      };
    }
    case SET_REMOVE_MEDIA_ARRAY: {
      const { removeMediaArray } = state;
      // eslint-disable-next-line radix
      const newArray = [...removeMediaArray, parseInt(action.payload)];
      return {
        ...state,
        removeMediaArray: newArray,
      };
    }
    case CLEAR_REMOVE_MEDIA_ARRAY: {
      return {
        ...state,
        removeMediaArray: [],
      };
    }
    case SET_MESSAGE_MEDIA_URL: {
      return {
        ...state,
        messageMediaUrl: action.payload,
      };
    }
    case SET_ACTIVE_REDUX_MODAL: {
      return {
        ...state,
        activeModal: action.payload,
      };
    }
    case SET_SUB_ACTIVE_REDUX_MODAL: {
      return {
        ...state,
        activeSubModal: action.payload,
      };
    }
    case SET_JOURNAL_TAB: {
      return {
        ...state,
        activeTab: action.payload,
      };
    }
    case CREATE_JOURNAL_ENTRY_COMMENT_START: {
      return {
        ...state,
        commentError: {},
      };
    }
    case CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED: {
      const journalEntry = state.journalEntriesData.find((entry) => (
        entry.id === action.payload.journalEntryId
      ));
      const updatedComments = [action.payload.data, ...journalEntry.comments];
      return {
        ...state,
        journalEntriesData: state.journalEntriesData.map((entry) => {
          if (entry.id === journalEntry.id) {
            return {
              ...entry,
              comments: updatedComments,
            };
          }
          return entry;
        }),
        removeMediaArray: [],
        commentUploadMedia: {},
      };
    }
    case CREATE_JOURNAL_ENTRY_COMMENT_REJECTED: {
      return {
        ...state,
        commentError: action.payload,
      };
    }
    case SET_EDIT_COMMENT: {
      return {
        ...state,
        editedComment: {
          entryId: action.payload.entryId,
          comment: action.payload.comment,
        },
        commentUploadMedia: action.payload.mediaObj,
      };
    }
    case EDIT_JOURNAL_ENTRY_COMMENT_START: {
      return {
        ...state,
        commentError: {},
      };
    }
    case EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED: {
      const journalEntry = state.journalEntriesData.find((entry) => (
        entry.id === action.payload.journalEntryId
      ));
      const entryComment = journalEntry.comments.find((comment) => (
        comment.id === action.payload.journalEntryCommentId
      ));
      const updatedComments = journalEntry.comments.map((comment) => {
        if (comment.id === entryComment.id) {
          return action.payload.data;
        }
        return comment;
      });
      return {
        ...state,
        journalEntriesData: state.journalEntriesData.map((entry) => {
          if (entry.id === journalEntry.id) {
            return {
              ...entry,
              comments: updatedComments,
            };
          }
          return entry;
        }),
        removeMediaArray: [],
        commentUploadMedia: {},
        editedComment: {},
      };
    }
    case EDIT_JOURNAL_ENTRY_COMMENT_REJECTED: {
      return {
        ...state,
        commentError: action.payload,
      };
    }
    case DELETE_JOURNAL_ENTRY_COMMENT_START: {
      return {
        ...state,
        commentError: null,
      };
    }
    case DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED: {
      const journalEntry = state.journalEntriesData.find((entry) => (
        entry.id === action.payload.journalEntryId
      ));
      const updatedComments = journalEntry.comments.filter(
        (comment) => comment.id !== action.payload.journalEntryCommentId,
      );
      return {
        ...state,
        journalEntriesData: state.journalEntriesData.map((entry) => {
          if (entry.id === journalEntry.id) {
            return {
              ...entry,
              comments: updatedComments,
            };
          }
          return entry;
        }),
      };
    }
    case DELETE_JOURNAL_ENTRY_COMMENT_REJECTED: {
      return {
        ...state,
        commentError: action.payload,
      };
    }
    case SET_REPORT_POST_ID: {
      return {
        ...state,
        reportPost: {
          type: action.payload.type,
          id: action.payload.id,
        },
      };
    }
    case SUBMIT_SUPPORT_START: {
      return {
        ...state,
        submitSupportError: null,
      };
    }
    case SUBMIT_SUPPORT_FULFILLED: {
      return {
        ...state,
        activeModal: '',
        reportPost: null,
      };
    }
    case SUBMIT_SUPPORT_REJECTED: {
      return {
        ...state,
        submitSupportError: action.payload,
      };
    }
    case RESET_ENTRY_ERROR: {
      return {
        ...state,
        entryError: null,
      };
    }
    case RESET_COMMENT_ERROR: {
      return {
        ...state,
        commentError: {},
      };
    }
    case RESET_SUPPORT_ERROR: {
      return {
        ...state,
        submitSupportError: null,
      };
    }
    default: {
      return state;
    }
  }
}
